// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700&family=Noto+Sans+KR:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 여권 등록 페이지 스타일
 * 테마: Regal Ceremonial (로얄 퍼플 + 앤틱 골드)
 * 현장 데스크용 큰 폰트 & 터치 친화적 UI
 */

/* Google Fonts */

/* ==========================================
   CSS 변수 - Regal Theme
   ========================================== */
:root {
  --royal-purple: #7B1FA2;
  --royal-purple-deep: #4A148C;
  --royal-purple-light: #E1BEE7;
  --antique-gold: #D4AF37;
  --antique-gold-light: #F4E4BC;
  --antique-gold-dark: #B8960C;
  --ivory: #FFFEF7;
  --parchment: #F8F4E8;
  --ink: #2D1B4E;
  --ink-light: #5E4A7E;
}

/* ==========================================
   페이지 레이아웃
   ========================================== */
.passport-register-page {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  background: linear-gradient(180deg, var(--parchment) 0%, var(--ivory) 100%);
  font-family: 'Noto Sans KR', sans-serif;
  position: relative;
  overflow: hidden;
}

/* 글로벌 min-height 오버라이드 */
.passport-register-page button,
.passport-register-page input,
.passport-register-page select {
  min-height: auto !important;
}

/* ==========================================
   배경 장식
   ========================================== */
.page-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 0;
}

.deco-circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.08;
}

.deco-1 {
  width: 400px;
  height: 400px;
  background: var(--royal-purple);
  top: -150px;
  right: -100px;
}

.deco-2 {
  width: 300px;
  height: 300px;
  background: var(--antique-gold);
  bottom: -100px;
  left: -80px;
}

.deco-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    radial-gradient(circle at 20% 50%, rgba(123, 31, 162, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(212, 175, 55, 0.03) 0%, transparent 50%);
}

/* ==========================================
   헤더
   ========================================== */
.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);
  padding: 8px 16px;
  position: relative;
  z-index: 10;
  box-shadow: 0 4px 20px rgba(74, 20, 140, 0.3);
  flex-shrink: 0;
}

.page-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--antique-gold), var(--antique-gold-light), var(--antique-gold));
}

.btn-back {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 12px;
  transition: all 0.2s;
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.25);
}

.btn-back:active {
  transform: scale(0.97);
}

.header-title-area {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon {
  font-size: 36px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.page-header h1 {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  margin: 0;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.header-badge {
  background: linear-gradient(135deg, var(--antique-gold) 0%, var(--antique-gold-dark) 100%);
  color: var(--royal-purple-deep);
  font-size: 16px;
  font-weight: 700;
  padding: 8px 20px;
  border-radius: 20px;
  letter-spacing: 2px;
  box-shadow: 0 2px 8px rgba(212, 175, 55, 0.4);
}

/* ==========================================
   메인 컨텐츠
   ========================================== */
.page-content {
  flex: 1 1;
  padding: 12px 16px;
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  overflow: hidden;
}

/* ==========================================
   회원 조회 섹션
   ========================================== */
.search-section {
  animation: fadeInUp 0.5s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 전화번호 검색 */
.phone-search {
  background: #fff;
  border-radius: 20px;
  padding: 14px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* 전화번호 표시 영역 */
.phone-display {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
  padding: 10px 16px;
  background: #f8f8f8;
  border: 3px solid var(--royal-purple-light);
  border-radius: 14px;
}

.phone-prefix {
  font-size: 24px;
}

.phone-number-text {
  flex: 1 1;
  font-size: 28px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: 3px;
}

.phone-number-text.placeholder {
  font-size: 20px;
  font-weight: 400;
  color: #bbb;
  letter-spacing: 0;
}

/* 커스텀 번호패드 */
.numpad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  margin-bottom: 10px;
}

.numpad-btn {
  padding: 10px;
  font-size: 20px;
  font-weight: 600;
  color: var(--ink);
  background: #f5f5f5;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.1s;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.numpad-btn:active {
  background: var(--royal-purple-light);
  border-color: var(--royal-purple);
  transform: scale(0.95);
}

.numpad-clear {
  font-size: 14px;
  font-weight: 500;
  color: #C62828;
  background: #FFEBEE;
  border-color: #EF9A9A;
}

.numpad-clear:active {
  background: #FFCDD2;
  border-color: #E57373;
}

.numpad-backspace {
  font-size: 22px;
  color: var(--ink-light);
  background: #EEEEEE;
  border-color: #BDBDBD;
}

.numpad-backspace:active {
  background: #E0E0E0;
  border-color: #9E9E9E;
}

.btn-search {
  width: 100%;
  padding: 12px;
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);
  color: #fff;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-search:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.btn-search:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(123, 31, 162, 0.4);
}

.btn-search:not(:disabled):active {
  transform: translateY(0);
}

/* 로딩 표시 */
.searching-indicator {
  text-align: center;
  padding: 48px;
}

.loading-spinner {
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-spinner.large {
  width: 48px;
  height: 48px;
  border-width: 4px;
  border-color: rgba(123, 31, 162, 0.2);
  border-top-color: var(--royal-purple);
  margin-bottom: 16px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.searching-indicator p {
  font-size: 22px;
  color: var(--ink-light);
  margin: 0;
}

/* ==========================================
   회원 정보 섹션
   ========================================== */
.member-section {
  animation: fadeInUp 0.5s ease;
}

.member-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 16px;
  padding: 10px 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  margin-bottom: 8px;
}

.member-avatar {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, var(--royal-purple-light) 0%, #f3e5f5 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  flex-shrink: 0;
}

.member-info {
  flex: 1 1;
}

.member-name {
  font-size: 20px;
  font-weight: 700;
  color: var(--ink);
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.vip-tag {
  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);
  color: var(--antique-gold);
  font-size: 14px;
  font-weight: 700;
  padding: 4px 14px;
  border-radius: 20px;
  letter-spacing: 2px;
  border: 1px solid var(--antique-gold);
}

.member-child-tag {
  font-size: 14px;
  font-weight: 500;
  color: #0891b2;
  margin-left: 4px;
}

/* 가족 여권 현황 */
.family-passport-section {
  margin-top: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 18px;
  max-height: 420px;
  overflow-y: auto;
}

.family-passport-title {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #334155;
  margin: 0 0 8px;
}

/* 여권 카드 그리드 */
.fp-card-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 8px;
}
.fp-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.2s;
}
.fp-card:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.fp-card-image {
  width: 100%;
  aspect-ratio: 3 / 4;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  overflow: hidden;
}
.fp-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.fp-card-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: linear-gradient(145deg, #7B1FA2, #4A148C);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
.fp-card-image {
  position: relative;
}
.fp-card-store-label {
  position: absolute;
  bottom: 6px;
  left: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  text-shadow: 0 1px 3px rgba(0,0,0,0.6);
}

.fp-card-delete {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  min-height: auto;
  border: none;
  border-radius: 50%;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.fp-card-delete:active { background: #C62828; }
.fp-card-delete:disabled { opacity: 0.3; cursor: not-allowed; }

.fp-card-bottom {
  padding: 6px 8px;
}
.fp-card-select {
  width: 100%;
  padding: 5px 6px;
  font-size: 12px;
  font-family: 'Noto Sans KR', sans-serif;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  color: #334155;
  cursor: pointer;
}
.fp-card-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.fp-empty-message {
  text-align: center;
  color: #999;
  font-size: 13px;
  padding: 20px 0;
  margin: 0;
}

.family-passport-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.family-passport-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 14px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.family-passport-row.current {
  border-color: #60a5fa;
  background: #eff6ff;
}

.fp-name {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 6px;
}

.fp-child-tag {
  font-size: 11px;
  font-weight: 500;
  color: #0891b2;
  background: #ecfeff;
  padding: 1px 6px;
  border-radius: 6px;
}

.fp-status.active {
  font-size: 13px;
  color: #16a34a;
  font-weight: 500;
}

.fp-btn-register {
  padding: 4px 12px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
}

.fp-btn-register:hover { opacity: 0.85; }
.fp-btn-register:active { transform: scale(0.97); }

.fp-checkbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.fp-checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #3b82f6;
  cursor: pointer;
}

.fp-checkbox-text {
  font-size: 13px;
  font-weight: 500;
  color: #3b82f6;
}

.fp-btn-batch {
  width: 100%;
  margin-top: 8px;
  padding: 8px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
}

.fp-btn-batch:hover:not(:disabled) { opacity: 0.85; }
.fp-btn-batch:active:not(:disabled) { transform: scale(0.98); }
.fp-btn-batch:disabled { opacity: 0.5; cursor: not-allowed; }

.fp-batch-result {
  margin-top: 6px;
  padding: 8px 12px;
  background: #ecfdf5;
  border: 1px solid #6ee7b7;
  border-radius: 8px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #059669;
  text-align: center;
}

.member-phone {
  font-size: 16px;
  color: var(--ink-light);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.member-visits-inline {
  font-size: 13px;
  color: #888;
}

.member-visits-inline strong {
  color: var(--royal-purple);
}

/* 상태 카드 */
.status-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 12px;
}

.status-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}

.status-content h3 {
  font-size: 16px;
  margin: 0 0 4px 0;
}

.status-content p {
  font-size: 14px;
  margin: 0;
  opacity: 0.8;
}

.status-active {
  background: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);
  border: 2px solid #81C784;
}

.status-active .status-icon {
  background: #4CAF50;
  color: #fff;
}

.status-active h3 {
  color: #2E7D32;
}

.status-active p {
  color: #388E3C;
}

.status-expired {
  background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);
  border: 2px solid #FFB74D;
}

.status-expired .status-icon {
  background: #FF9800;
  color: #fff;
}

.status-expired h3 {
  color: #E65100;
}

.status-expired p {
  color: #F57C00;
}

.existing-passport {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
}

.ep-id {
  font-family: monospace;
  font-size: 14px;
  color: #555;
}

.ep-expiry {
  font-size: 14px;
  font-weight: 600;
  color: var(--royal-purple);
}

/* ==========================================
   등록 섹션
   ========================================== */
.register-section {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  border: 2px solid var(--royal-purple-light);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 16px 0;
}

.title-icon {
  font-size: 30px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 8px;
}

.form-group input[type="date"] {
  width: 100%;
  padding: 10px 14px;
  font-size: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  outline: none;
  transition: border-color 0.2s;
  color: var(--ink);
}

.form-group input[type="date"]:focus {
  border-color: var(--royal-purple);
}

.form-hint {
  display: block;
  margin-top: 6px;
  font-size: 13px;
  color: var(--ink-light);
}

.btn-register {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px;
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);
  color: #fff;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 16px rgba(123, 31, 162, 0.3);
}

.btn-register:disabled {
  background: #ccc;
  box-shadow: none;
  cursor: not-allowed;
}

.btn-register:not(:disabled):hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 28px rgba(123, 31, 162, 0.4);
}

.btn-register:not(:disabled):active {
  transform: translateY(0);
}

.btn-icon {
  font-size: 32px;
}

.register-note {
  margin-top: 12px;
  padding: 10px 14px;
  background: #FFF8E1;
  border-radius: 10px;
  border-left: 4px solid var(--antique-gold);
}

.register-note p {
  margin: 0;
  font-size: 14px;
  color: #5D4037;
}

/* 여권 히스토리 버튼 */
.btn-history {
  width: 100%;
  margin-top: 10px;
  padding: 14px;
  border: 2px solid var(--antique-gold, #D4AF37);
  border-radius: 14px;
  background: #FFFDF5;
  color: #5D4037;
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-history:hover { background: #FFF8E1; }
.btn-history:active { transform: scale(0.97); }

/* 여권 히스토리 팝업 */
.history-popup {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 560px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}
.history-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}
.history-popup-header h3 {
  margin: 0;
  font-family: 'Jua', sans-serif;
  font-size: 18px;
  color: #333;
}
.history-popup-close {
  background: none;
  border: none;
  font-size: 22px;
  color: #999;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
}
.history-popup-close:hover { background: #f0f0f0; color: #333; }
.history-popup-body {
  padding: 12px 16px;
  overflow-y: auto;
  flex: 1 1;
}
.history-empty {
  text-align: center;
  color: #999;
  padding: 32px 0;
  font-size: 15px;
}

/* 에러 메시지 */
.error-message {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0;
  padding: 10px 14px;
  background: #FFEBEE;
  border: 2px solid #EF9A9A;
  border-radius: 10px;
}

.error-message .error-icon {
  width: 24px;
  height: 24px;
  background: #F44336;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.error-message p {
  margin: 0;
  font-size: 15px;
  color: #C62828;
}

/* ==========================================
   결과 섹션
   ========================================== */
.result-section {
  position: relative;
  animation: fadeInUp 0.5s ease;
  max-height: 100%;
  overflow-y: auto;
}

/* 컨페티 */
.confetti-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 100;
}

.confetti {
  position: absolute;
  top: -20px;
  width: 12px;
  height: 12px;
  animation: confettiFall 4s ease-out forwards;
}

@keyframes confettiFall {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(720deg);
    opacity: 0;
  }
}

.result-card {
  background: #fff;
  border-radius: 16px;
  padding: 14px 20px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  z-index: 10;
}

.result-header {
  margin-bottom: 10px;
}

.success-icon {
  position: relative;
  width: 50px;
  height: 50px;
  margin: 0 auto 8px;
}

.success-icon .crown {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 28px;
  animation: crownBounce 1s ease-out;
}

@keyframes crownBounce {
  0% {
    transform: translateX(-50%) translateY(-30px) scale(0);
  }
  50% {
    transform: translateX(-50%) translateY(5px) scale(1.2);
  }
  100% {
    transform: translateX(-50%) translateY(0) scale(1);
  }
}

.success-icon .checkmark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);
  border-radius: 50%;
  font-size: 24px;
  color: var(--antique-gold);
  animation: scaleIn 0.5s ease-out;
  box-shadow: 0 4px 20px rgba(123, 31, 162, 0.4);
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
  }
  60% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.result-header h2 {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--ink);
  margin: 0 0 4px 0;
}

.result-subtitle {
  font-size: 14px;
  color: var(--ink-light);
  margin: 0;
}

/* 여권 프리뷰 카드 */
.passport-preview {
  margin-bottom: 10px;
}

.passport-card {
  max-width: 100%;
  margin: 0;
  background: linear-gradient(145deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);
  border-radius: 14px;
  padding: 14px 18px;
  box-shadow:
    0 8px 32px rgba(74, 20, 140, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  color: #fff;
  text-align: left;
  position: relative;
  overflow: hidden;
}

.passport-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, rgba(212, 175, 55, 0.15) 0%, transparent 70%);
}

.passport-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.passport-emblem {
  font-size: 36px;
}

.passport-title {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 1px;
}

.passport-card-body {
  position: relative;
  z-index: 1;
}

.passport-field {
  margin-bottom: 8px;
}

.passport-field .field-label {
  display: block;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.7;
  margin-bottom: 4px;
}

.passport-field .field-value {
  font-size: 18px;
  font-weight: 500;
}

.passport-field .field-value.passport-id {
  font-family: monospace;
  font-size: 16px;
  color: var(--antique-gold-light);
  letter-spacing: 1px;
}

.passport-dates {
  display: flex;
  gap: 24px;
}

.passport-dates .passport-field {
  flex: 1 1;
}

.passport-card-footer {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  text-align: right;
}

.validity {
  display: inline-block;
  padding: 8px 20px;
  background: var(--antique-gold);
  color: var(--royal-purple-deep);
  font-size: 18px;
  font-weight: 700;
  border-radius: 20px;
}

/* 혜택 요약 */
.benefits-summary {
  margin-bottom: 10px;
}

.benefits-summary h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 8px 0;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  background: var(--parchment);
  border-radius: 10px;
  border: 1px solid rgba(123, 31, 162, 0.1);
}

.benefit-icon {
  font-size: 20px;
}

.benefit-char {
  width: 28px;
  height: 28px;
  object-fit: cover;
  border-radius: 50%;
  flex-shrink: 0;
}

.passport-emblem-img {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50%;
  filter: drop-shadow(0 1px 3px rgba(0,0,0,0.3));
}

.benefit-text {
  font-size: 13px;
  color: var(--ink-light);
}

.benefit-text strong {
  color: var(--royal-purple);
}

/* 완료 버튼 */
.btn-complete {
  width: 100%;
  padding: 14px;
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
  color: #fff;
  border: none;
  border-radius: 18px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);
}

.btn-complete:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 28px rgba(76, 175, 80, 0.4);
}

.btn-complete:active {
  transform: translateY(0);
}

/* ==========================================
   미등록 회원 확인 팝업
   ========================================== */
.confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.confirm-popup {
  background: #fff;
  border-radius: 24px;
  padding: 36px 32px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow:
    0 16px 48px rgba(0, 0, 0, 0.2),
    0 0 0 3px var(--antique-gold);
  animation: popIn 0.3s ease;
}

.confirm-popup.auto-progress {
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
}

@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.confirm-icon {
  font-size: 56px;
  margin-bottom: 16px;
}

.confirm-popup h3 {
  font-size: 24px;
  font-weight: 700;
  color: var(--ink);
  margin: 0 0 12px 0;
}

.confirm-popup p {
  font-size: 18px;
  color: var(--ink-light);
  margin: 0 0 20px 0;
  line-height: 1.6;
}

.confirm-phone {
  display: inline-block;
  padding: 10px 24px;
  background: var(--parchment);
  border: 2px solid var(--royal-purple-light);
  border-radius: 12px;
  font-size: 22px;
  font-weight: 600;
  color: var(--royal-purple);
  letter-spacing: 2px;
  margin-bottom: 24px;
}

.confirm-buttons {
  display: flex;
  gap: 12px;
}

.btn-confirm-cancel {
  flex: 1 1;
  padding: 18px;
  font-size: 20px;
  font-weight: 600;
  background: #f5f5f5;
  color: #666;
  border: 2px solid #e0e0e0;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-confirm-cancel:active {
  background: #e0e0e0;
  transform: scale(0.97);
}

.btn-confirm-ok {
  flex: 1 1;
  padding: 18px;
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);
  color: #fff;
  border: 2px solid var(--antique-gold);
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(123, 31, 162, 0.3);
}

.btn-confirm-ok:active {
  transform: scale(0.97);
}

/* ==========================================
   통합 결과: 가입 정보 요약
   ========================================== */
.combined-member-summary {
  background: var(--parchment);
  border: 2px solid var(--antique-gold-light);
  border-radius: 16px;
  padding: 20px 24px;
  margin-bottom: 24px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.summary-row + .summary-row {
  border-top: 1px solid rgba(212, 175, 55, 0.2);
}

.summary-row.highlight {
  margin-top: 4px;
}

.summary-label {
  font-size: 18px;
  color: var(--ink-light);
}

.summary-value {
  font-size: 20px;
  font-weight: 600;
  color: var(--ink);
}

.summary-value.coins {
  color: var(--royal-purple);
  font-size: 24px;
  font-weight: 700;
}

/* ==========================================
   반응형
   ========================================== */
@media (max-width: 600px) {
  .page-header {
    padding: 16px 20px;
    gap: 12px;
  }

  .page-header h1 {
    font-size: 26px;
  }

  .header-icon {
    font-size: 28px;
  }

  .header-badge {
    font-size: 12px;
    padding: 6px 14px;
  }

  .page-content {
    padding: 20px;
  }

  .member-card {
    flex-direction: column;
    text-align: center;
  }

  .member-name {
    justify-content: center;
    flex-wrap: wrap;
  }

  .passport-card {
    padding: 20px;
  }

  .benefits-grid {
    grid-template-columns: 1fr;
  }
}

/* 여권 발급 히스토리 */
.passport-history {
  background: #fff;
  border-radius: 12px;
  padding: 10px 12px;
  margin-top: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.passport-history-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 8px;
}

.passport-history-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.passport-history-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 8px;
  font-size: 12px;
  background: #f8f8f8;
  border-left: 3px solid #ccc;
  white-space: nowrap;
}

.passport-history-row.active {
  border-left-color: #4CAF50;
  background: #F1F8E9;
}

.passport-history-row.expired {
  border-left-color: #BDBDBD;
  background: #FAFAFA;
  color: #999;
}

.passport-history-row.cancelled {
  border-left-color: #EF5350;
  background: #FFF5F5;
  color: #bbb;
}

.ph-strikethrough {
  text-decoration: line-through;
  color: #bbb !important;
}

.ph-status.cancelled {
  color: #EF5350 !important;
  font-weight: 600;
}

.passport-history-row.event {
  border-left-color: #7B1FA2;
  background: #F3E5F5;
}
.ph-status.event {
  color: #7B1FA2 !important;
  font-weight: 600;
}

.passport-history-row.current-store {
  border-left-color: var(--royal-purple);
  background: #F3E5F5;
}

.ph-store {
  font-weight: 600;
  min-width: 60px;
  color: var(--ink);
}

.passport-history-row.expired .ph-store {
  color: #999;
}

.ph-issue, .ph-expire {
  color: #666;
  font-size: 11px;
}

.ph-status {
  font-weight: 700;
  font-size: 11px;
  margin-left: auto;
}

.ph-status.active { color: #2E7D32; }
.ph-status.expired { color: #999; }

.ph-dup {
  background: var(--royal-purple);
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
}

.ph-assign-select {
  padding: 3px 6px;
  border: 1px solid #AB47BC;
  border-radius: 6px;
  background: #F3E5F5;
  color: #7B1FA2;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  max-width: 120px;
}

.ph-assign-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ph-cancel-btn {
  padding: 3px 8px;
  border: 1px solid #ef5350;
  border-radius: 6px;
  background: #ffebee;
  color: #c62828;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.ph-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ph-cancel-btn:not(:disabled):hover {
  background: #ef5350;
  color: #fff;
}

/* 통합 여권 현황 */
.fp-summary-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #FFF8E1;
  border-radius: 8px;
  font-size: 13px;
  color: #555;
  margin-bottom: 8px;
}

.fp-summary-divider {
  color: #ccc;
}

.fp-current-tag {
  display: inline-block;
  background: #E3F2FD;
  color: #1565C0;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 4px;
  margin-left: 4px;
}

.fp-btn-assign {
  padding: 4px 10px;
  border: 1px solid #FF9800;
  border-radius: 6px;
  background: #FFF3E0;
  color: #E65100;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.fp-btn-assign:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.fp-btn-assign:not(:disabled):active {
  background: #FFE0B2;
}

.fp-status.none {
  font-size: 12px;
  color: #999;
}

.fp-passport-count {
  font-size: 13px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
}

.fp-store-tags {
  display: inline-flex;
  gap: 3px;
  margin-left: 4px;
}

.fp-store-tag-group {
  display: inline-flex;
  align-items: center;
  gap: 1px;
  margin-left: 3px;
}

.fp-store-tag {
  display: inline-block;
  background: #E8F5E9;
  color: #2E7D32;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 4px 0 0 4px;
}

.fp-tag-recall {
  background: #E3F2FD;
  color: #1565C0;
  border: none;
  font-size: 10px;
  padding: 1px 4px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  line-height: 1;
}

.fp-tag-recall:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.fp-tag-recall:not(:disabled):active {
  background: #1565C0;
  color: #fff;
}

.fp-passport-list {
  margin-top: 8px;
  border-top: 1px solid #eee;
  padding-top: 8px;
  max-height: 180px;
  overflow-y: auto;
}

.fp-passport-list-title {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 6px;
}

.ph-owner {
  font-size: 11px;
  font-weight: 600;
  color: #7B1FA2;
  min-width: 45px;
}

/* USB 바코드/QR 리더기 섹션 */
.barcode-reader-section {
  background: #fff;
  border-radius: 14px;
  padding: 20px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 3px dashed var(--royal-purple-light);
}

.barcode-icon {
  font-size: 48px;
  margin-bottom: 8px;
}

.barcode-title {
  font-family: 'Jua', sans-serif;
  font-size: 18px;
  color: var(--royal-purple);
  margin: 0 0 4px;
}

.barcode-hint {
  font-size: 13px;
  color: var(--ink-light);
  margin: 0 0 16px;
}


/* 여권 페이지 카메라 스캐너 오버라이드 (미사용, 하위 호환) */
.passport-scanner-wrap {
  flex: 1 1;
  border-radius: 10px;
  overflow: hidden;
}

.passport-scanner-wrap .qr-scanner {
  max-width: none !important;
  flex-direction: column !important;
  height: 100%;
}

.passport-scanner-wrap .qr-scanner-viewport {
  width: 100% !important;
  height: 100% !important;
  aspect-ratio: auto !important;
}

.passport-scanner-wrap .qr-scanner-guide {
  margin-top: 4px !important;
  font-size: 12px !important;
  writing-mode: horizontal-tb !important;
}

.passport-scanner-wrap .qr-scanner-error {
  aspect-ratio: auto !important;
  height: 100% !important;
}

/* 커스텀 확인 팝업 */
.pp-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.pp-confirm-popup {
  background: #fff;
  border-radius: 16px;
  padding: 28px 32px;
  max-width: 340px;
  width: 90%;
  text-align: center;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
}

.pp-confirm-icon {
  font-size: 40px;
  margin-bottom: 12px;
}

.pp-confirm-message {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  margin: 0 0 20px;
  white-space: pre-line;
}

.pp-confirm-buttons {
  display: flex;
  gap: 10px;
}

.pp-confirm-cancel {
  flex: 1 1;
  padding: 12px;
  border: 2px solid #ddd;
  border-radius: 12px;
  background: #fff;
  color: #666;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.pp-confirm-cancel:active {
  background: #f5f5f5;
}

.pp-confirm-ok {
  flex: 1 1;
  padding: 12px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #ef5350, #c62828);
  color: #fff;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.pp-confirm-ok:active {
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PassportRegisterPage.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,iBAAiB;;AAGjB;;+CAE+C;AAC/C;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,2EAA2E;EAC3E,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;;;EAGE,2BAA2B;AAC7B;;AAEA;;+CAE+C;AAC/C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;oFAEkF;AACpF;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0FAA0F;EAC1F,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uGAAuG;AACzG;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,0FAA0F;EAC1F,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;+CAE+C;AAC/C;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;;+CAE+C;AAC/C;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,0FAA0F;EAC1F,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;;+CAE+C;AAC/C;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+EAA+E;EAC/E,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0FAA0F;EAC1F,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,yBAAyB,aAAa,EAAE;AACxC,0BAA0B,sBAAsB,EAAE;;AAElD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,qCAAqC,aAAa,EAAE;AACpD,sCAAsC,sBAAsB,EAAE;AAC9D,yBAAyB,YAAY,EAAE,mBAAmB,EAAE;;AAE5D;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;+CAE+C;AAC/C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,0FAA0F;EAC1F,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,qBAAqB;AACvB;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,sBAAsB,sBAAsB,EAAE;;AAE9C,eAAe;AACf;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA,6BAA6B,mBAAmB,EAAE,WAAW,EAAE;AAC/D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;;+CAE+C;AAC/C;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,sDAAsD;EACxD;EACA;IACE,sDAAsD;EACxD;EACA;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0FAA0F;EAC1F,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,0FAA0F;EAC1F,mBAAmB;EACnB,kBAAkB;EAClB;;0CAEwC;EACxC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;+CAE+C;AAC/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB;;iCAE+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;EAC5B,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,0FAA0F;EAC1F,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;+CAE+C;AAC/C;EACE,4BAA4B;EAC5B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;+CAE+C;AAC/C;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,oBAAoB,cAAc,EAAE;AACpC,qBAAqB,WAAW,EAAE;;AAElC;EACE,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;;AAGA,sCAAsC;AACtC;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd","sourcesContent":["/**\n * 여권 등록 페이지 스타일\n * 테마: Regal Ceremonial (로얄 퍼플 + 앤틱 골드)\n * 현장 데스크용 큰 폰트 & 터치 친화적 UI\n */\n\n/* Google Fonts */\n@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700&family=Noto+Sans+KR:wght@400;500;600;700&display=swap');\n\n/* ==========================================\n   CSS 변수 - Regal Theme\n   ========================================== */\n:root {\n  --royal-purple: #7B1FA2;\n  --royal-purple-deep: #4A148C;\n  --royal-purple-light: #E1BEE7;\n  --antique-gold: #D4AF37;\n  --antique-gold-light: #F4E4BC;\n  --antique-gold-dark: #B8960C;\n  --ivory: #FFFEF7;\n  --parchment: #F8F4E8;\n  --ink: #2D1B4E;\n  --ink-light: #5E4A7E;\n}\n\n/* ==========================================\n   페이지 레이아웃\n   ========================================== */\n.passport-register-page {\n  display: flex;\n  flex-direction: column;\n  height: 100dvh;\n  background: linear-gradient(180deg, var(--parchment) 0%, var(--ivory) 100%);\n  font-family: 'Noto Sans KR', sans-serif;\n  position: relative;\n  overflow: hidden;\n}\n\n/* 글로벌 min-height 오버라이드 */\n.passport-register-page button,\n.passport-register-page input,\n.passport-register-page select {\n  min-height: auto !important;\n}\n\n/* ==========================================\n   배경 장식\n   ========================================== */\n.page-decoration {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.deco-circle {\n  position: absolute;\n  border-radius: 50%;\n  opacity: 0.08;\n}\n\n.deco-1 {\n  width: 400px;\n  height: 400px;\n  background: var(--royal-purple);\n  top: -150px;\n  right: -100px;\n}\n\n.deco-2 {\n  width: 300px;\n  height: 300px;\n  background: var(--antique-gold);\n  bottom: -100px;\n  left: -80px;\n}\n\n.deco-pattern {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image:\n    radial-gradient(circle at 20% 50%, rgba(123, 31, 162, 0.03) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(212, 175, 55, 0.03) 0%, transparent 50%);\n}\n\n/* ==========================================\n   헤더\n   ========================================== */\n.page-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);\n  padding: 8px 16px;\n  position: relative;\n  z-index: 10;\n  box-shadow: 0 4px 20px rgba(74, 20, 140, 0.3);\n  flex-shrink: 0;\n}\n\n.page-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--antique-gold), var(--antique-gold-light), var(--antique-gold));\n}\n\n.btn-back {\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  font-size: 16px;\n  color: #fff;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: 12px;\n  transition: all 0.2s;\n}\n\n.btn-back:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.btn-back:active {\n  transform: scale(0.97);\n}\n\n.header-title-area {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.header-icon {\n  font-size: 36px;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n.page-header h1 {\n  font-family: 'Playfair Display', serif;\n  font-size: 22px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n  letter-spacing: 1px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.header-badge {\n  background: linear-gradient(135deg, var(--antique-gold) 0%, var(--antique-gold-dark) 100%);\n  color: var(--royal-purple-deep);\n  font-size: 16px;\n  font-weight: 700;\n  padding: 8px 20px;\n  border-radius: 20px;\n  letter-spacing: 2px;\n  box-shadow: 0 2px 8px rgba(212, 175, 55, 0.4);\n}\n\n/* ==========================================\n   메인 컨텐츠\n   ========================================== */\n.page-content {\n  flex: 1;\n  padding: 12px 16px;\n  position: relative;\n  z-index: 1;\n  max-width: 800px;\n  margin: 0 auto;\n  width: 100%;\n  overflow: hidden;\n}\n\n/* ==========================================\n   회원 조회 섹션\n   ========================================== */\n.search-section {\n  animation: fadeInUp 0.5s ease;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* 전화번호 검색 */\n.phone-search {\n  background: #fff;\n  border-radius: 20px;\n  padding: 14px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n}\n\n/* 전화번호 표시 영역 */\n.phone-display {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 10px;\n  padding: 10px 16px;\n  background: #f8f8f8;\n  border: 3px solid var(--royal-purple-light);\n  border-radius: 14px;\n}\n\n.phone-prefix {\n  font-size: 24px;\n}\n\n.phone-number-text {\n  flex: 1;\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--ink);\n  letter-spacing: 3px;\n}\n\n.phone-number-text.placeholder {\n  font-size: 20px;\n  font-weight: 400;\n  color: #bbb;\n  letter-spacing: 0;\n}\n\n/* 커스텀 번호패드 */\n.numpad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 5px;\n  margin-bottom: 10px;\n}\n\n.numpad-btn {\n  padding: 10px;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--ink);\n  background: #f5f5f5;\n  border: 2px solid #e8e8e8;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.1s;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.numpad-btn:active {\n  background: var(--royal-purple-light);\n  border-color: var(--royal-purple);\n  transform: scale(0.95);\n}\n\n.numpad-clear {\n  font-size: 14px;\n  font-weight: 500;\n  color: #C62828;\n  background: #FFEBEE;\n  border-color: #EF9A9A;\n}\n\n.numpad-clear:active {\n  background: #FFCDD2;\n  border-color: #E57373;\n}\n\n.numpad-backspace {\n  font-size: 22px;\n  color: var(--ink-light);\n  background: #EEEEEE;\n  border-color: #BDBDBD;\n}\n\n.numpad-backspace:active {\n  background: #E0E0E0;\n  border-color: #9E9E9E;\n}\n\n.btn-search {\n  width: 100%;\n  padding: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-search:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.btn-search:not(:disabled):hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(123, 31, 162, 0.4);\n}\n\n.btn-search:not(:disabled):active {\n  transform: translateY(0);\n}\n\n/* 로딩 표시 */\n.searching-indicator {\n  text-align: center;\n  padding: 48px;\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.loading-spinner.large {\n  width: 48px;\n  height: 48px;\n  border-width: 4px;\n  border-color: rgba(123, 31, 162, 0.2);\n  border-top-color: var(--royal-purple);\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.searching-indicator p {\n  font-size: 22px;\n  color: var(--ink-light);\n  margin: 0;\n}\n\n/* ==========================================\n   회원 정보 섹션\n   ========================================== */\n.member-section {\n  animation: fadeInUp 0.5s ease;\n}\n\n.member-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border-radius: 16px;\n  padding: 10px 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  margin-bottom: 8px;\n}\n\n.member-avatar {\n  width: 56px;\n  height: 56px;\n  background: linear-gradient(135deg, var(--royal-purple-light) 0%, #f3e5f5 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  flex-shrink: 0;\n}\n\n.member-info {\n  flex: 1;\n}\n\n.member-name {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--ink);\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.vip-tag {\n  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);\n  color: var(--antique-gold);\n  font-size: 14px;\n  font-weight: 700;\n  padding: 4px 14px;\n  border-radius: 20px;\n  letter-spacing: 2px;\n  border: 1px solid var(--antique-gold);\n}\n\n.member-child-tag {\n  font-size: 14px;\n  font-weight: 500;\n  color: #0891b2;\n  margin-left: 4px;\n}\n\n/* 가족 여권 현황 */\n.family-passport-section {\n  margin-top: 10px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 10px 18px;\n  max-height: 420px;\n  overflow-y: auto;\n}\n\n.family-passport-title {\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #334155;\n  margin: 0 0 8px;\n}\n\n/* 여권 카드 그리드 */\n.fp-card-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n  margin-top: 8px;\n}\n.fp-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: box-shadow 0.2s;\n}\n.fp-card:hover {\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n.fp-card-image {\n  width: 100%;\n  aspect-ratio: 3 / 4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f5f9;\n  overflow: hidden;\n}\n.fp-card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.fp-card-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(145deg, #7B1FA2, #4A148C);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n}\n.fp-card-image {\n  position: relative;\n}\n.fp-card-store-label {\n  position: absolute;\n  bottom: 6px;\n  left: 8px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  text-shadow: 0 1px 3px rgba(0,0,0,0.6);\n}\n\n.fp-card-delete {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 22px;\n  height: 22px;\n  min-height: auto;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0,0,0,0.5);\n  color: #fff;\n  font-size: 12px;\n  line-height: 1;\n  cursor: pointer;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n.fp-card-delete:active { background: #C62828; }\n.fp-card-delete:disabled { opacity: 0.3; cursor: not-allowed; }\n\n.fp-card-bottom {\n  padding: 6px 8px;\n}\n.fp-card-select {\n  width: 100%;\n  padding: 5px 6px;\n  font-size: 12px;\n  font-family: 'Noto Sans KR', sans-serif;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fff;\n  color: #334155;\n  cursor: pointer;\n}\n.fp-card-select:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.fp-empty-message {\n  text-align: center;\n  color: #999;\n  font-size: 13px;\n  padding: 20px 0;\n  margin: 0;\n}\n\n.family-passport-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.family-passport-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 14px;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.family-passport-row.current {\n  border-color: #60a5fa;\n  background: #eff6ff;\n}\n\n.fp-name {\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.fp-child-tag {\n  font-size: 11px;\n  font-weight: 500;\n  color: #0891b2;\n  background: #ecfeff;\n  padding: 1px 6px;\n  border-radius: 6px;\n}\n\n.fp-status.active {\n  font-size: 13px;\n  color: #16a34a;\n  font-weight: 500;\n}\n\n.fp-btn-register {\n  padding: 4px 12px;\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n\n.fp-btn-register:hover { opacity: 0.85; }\n.fp-btn-register:active { transform: scale(0.97); }\n\n.fp-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.fp-checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #3b82f6;\n  cursor: pointer;\n}\n\n.fp-checkbox-text {\n  font-size: 13px;\n  font-weight: 500;\n  color: #3b82f6;\n}\n\n.fp-btn-batch {\n  width: 100%;\n  margin-top: 8px;\n  padding: 8px;\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n\n.fp-btn-batch:hover:not(:disabled) { opacity: 0.85; }\n.fp-btn-batch:active:not(:disabled) { transform: scale(0.98); }\n.fp-btn-batch:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.fp-batch-result {\n  margin-top: 6px;\n  padding: 8px 12px;\n  background: #ecfdf5;\n  border: 1px solid #6ee7b7;\n  border-radius: 8px;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #059669;\n  text-align: center;\n}\n\n.member-phone {\n  font-size: 16px;\n  color: var(--ink-light);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.member-visits-inline {\n  font-size: 13px;\n  color: #888;\n}\n\n.member-visits-inline strong {\n  color: var(--royal-purple);\n}\n\n/* 상태 카드 */\n.status-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  margin-bottom: 12px;\n}\n\n.status-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.status-content h3 {\n  font-size: 16px;\n  margin: 0 0 4px 0;\n}\n\n.status-content p {\n  font-size: 14px;\n  margin: 0;\n  opacity: 0.8;\n}\n\n.status-active {\n  background: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);\n  border: 2px solid #81C784;\n}\n\n.status-active .status-icon {\n  background: #4CAF50;\n  color: #fff;\n}\n\n.status-active h3 {\n  color: #2E7D32;\n}\n\n.status-active p {\n  color: #388E3C;\n}\n\n.status-expired {\n  background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);\n  border: 2px solid #FFB74D;\n}\n\n.status-expired .status-icon {\n  background: #FF9800;\n  color: #fff;\n}\n\n.status-expired h3 {\n  color: #E65100;\n}\n\n.status-expired p {\n  color: #F57C00;\n}\n\n.existing-passport {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 12px;\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 8px;\n}\n\n.ep-id {\n  font-family: monospace;\n  font-size: 14px;\n  color: #555;\n}\n\n.ep-expiry {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--royal-purple);\n}\n\n/* ==========================================\n   등록 섹션\n   ========================================== */\n.register-section {\n  background: #fff;\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  border: 2px solid var(--royal-purple-light);\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--ink);\n  margin: 0 0 16px 0;\n}\n\n.title-icon {\n  font-size: 30px;\n}\n\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--ink);\n  margin-bottom: 8px;\n}\n\n.form-group input[type=\"date\"] {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 12px;\n  outline: none;\n  transition: border-color 0.2s;\n  color: var(--ink);\n}\n\n.form-group input[type=\"date\"]:focus {\n  border-color: var(--royal-purple);\n}\n\n.form-hint {\n  display: block;\n  margin-top: 6px;\n  font-size: 13px;\n  color: var(--ink-light);\n}\n\n.btn-register {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 14px;\n  font-size: 20px;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.3s;\n  box-shadow: 0 4px 16px rgba(123, 31, 162, 0.3);\n}\n\n.btn-register:disabled {\n  background: #ccc;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.btn-register:not(:disabled):hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 28px rgba(123, 31, 162, 0.4);\n}\n\n.btn-register:not(:disabled):active {\n  transform: translateY(0);\n}\n\n.btn-icon {\n  font-size: 32px;\n}\n\n.register-note {\n  margin-top: 12px;\n  padding: 10px 14px;\n  background: #FFF8E1;\n  border-radius: 10px;\n  border-left: 4px solid var(--antique-gold);\n}\n\n.register-note p {\n  margin: 0;\n  font-size: 14px;\n  color: #5D4037;\n}\n\n/* 여권 히스토리 버튼 */\n.btn-history {\n  width: 100%;\n  margin-top: 10px;\n  padding: 14px;\n  border: 2px solid var(--antique-gold, #D4AF37);\n  border-radius: 14px;\n  background: #FFFDF5;\n  color: #5D4037;\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.btn-history:hover { background: #FFF8E1; }\n.btn-history:active { transform: scale(0.97); }\n\n/* 여권 히스토리 팝업 */\n.history-popup {\n  background: #fff;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 560px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n.history-popup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #eee;\n}\n.history-popup-header h3 {\n  margin: 0;\n  font-family: 'Jua', sans-serif;\n  font-size: 18px;\n  color: #333;\n}\n.history-popup-close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  color: #999;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 8px;\n}\n.history-popup-close:hover { background: #f0f0f0; color: #333; }\n.history-popup-body {\n  padding: 12px 16px;\n  overflow-y: auto;\n  flex: 1;\n}\n.history-empty {\n  text-align: center;\n  color: #999;\n  padding: 32px 0;\n  font-size: 15px;\n}\n\n/* 에러 메시지 */\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 8px 0;\n  padding: 10px 14px;\n  background: #FFEBEE;\n  border: 2px solid #EF9A9A;\n  border-radius: 10px;\n}\n\n.error-message .error-icon {\n  width: 24px;\n  height: 24px;\n  background: #F44336;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.error-message p {\n  margin: 0;\n  font-size: 15px;\n  color: #C62828;\n}\n\n/* ==========================================\n   결과 섹션\n   ========================================== */\n.result-section {\n  position: relative;\n  animation: fadeInUp 0.5s ease;\n  max-height: 100%;\n  overflow-y: auto;\n}\n\n/* 컨페티 */\n.confetti-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  z-index: 100;\n}\n\n.confetti {\n  position: absolute;\n  top: -20px;\n  width: 12px;\n  height: 12px;\n  animation: confettiFall 4s ease-out forwards;\n}\n\n@keyframes confettiFall {\n  0% {\n    transform: translateY(0) rotate(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(100vh) rotate(720deg);\n    opacity: 0;\n  }\n}\n\n.result-card {\n  background: #fff;\n  border-radius: 16px;\n  padding: 14px 20px;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  position: relative;\n  z-index: 10;\n}\n\n.result-header {\n  margin-bottom: 10px;\n}\n\n.success-icon {\n  position: relative;\n  width: 50px;\n  height: 50px;\n  margin: 0 auto 8px;\n}\n\n.success-icon .crown {\n  position: absolute;\n  top: -14px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 28px;\n  animation: crownBounce 1s ease-out;\n}\n\n@keyframes crownBounce {\n  0% {\n    transform: translateX(-50%) translateY(-30px) scale(0);\n  }\n  50% {\n    transform: translateX(-50%) translateY(5px) scale(1.2);\n  }\n  100% {\n    transform: translateX(-50%) translateY(0) scale(1);\n  }\n}\n\n.success-icon .checkmark {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);\n  border-radius: 50%;\n  font-size: 24px;\n  color: var(--antique-gold);\n  animation: scaleIn 0.5s ease-out;\n  box-shadow: 0 4px 20px rgba(123, 31, 162, 0.4);\n}\n\n@keyframes scaleIn {\n  0% {\n    transform: scale(0);\n  }\n  60% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.result-header h2 {\n  font-family: 'Playfair Display', serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--ink);\n  margin: 0 0 4px 0;\n}\n\n.result-subtitle {\n  font-size: 14px;\n  color: var(--ink-light);\n  margin: 0;\n}\n\n/* 여권 프리뷰 카드 */\n.passport-preview {\n  margin-bottom: 10px;\n}\n\n.passport-card {\n  max-width: 100%;\n  margin: 0;\n  background: linear-gradient(145deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);\n  border-radius: 14px;\n  padding: 14px 18px;\n  box-shadow:\n    0 8px 32px rgba(74, 20, 140, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n  color: #fff;\n  text-align: left;\n  position: relative;\n  overflow: hidden;\n}\n\n.passport-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 150px;\n  height: 150px;\n  background: radial-gradient(circle, rgba(212, 175, 55, 0.15) 0%, transparent 70%);\n}\n\n.passport-card-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.passport-emblem {\n  font-size: 36px;\n}\n\n.passport-title {\n  font-family: 'Playfair Display', serif;\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: 1px;\n}\n\n.passport-card-body {\n  position: relative;\n  z-index: 1;\n}\n\n.passport-field {\n  margin-bottom: 8px;\n}\n\n.passport-field .field-label {\n  display: block;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  opacity: 0.7;\n  margin-bottom: 4px;\n}\n\n.passport-field .field-value {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.passport-field .field-value.passport-id {\n  font-family: monospace;\n  font-size: 16px;\n  color: var(--antique-gold-light);\n  letter-spacing: 1px;\n}\n\n.passport-dates {\n  display: flex;\n  gap: 24px;\n}\n\n.passport-dates .passport-field {\n  flex: 1;\n}\n\n.passport-card-footer {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  text-align: right;\n}\n\n.validity {\n  display: inline-block;\n  padding: 8px 20px;\n  background: var(--antique-gold);\n  color: var(--royal-purple-deep);\n  font-size: 18px;\n  font-weight: 700;\n  border-radius: 20px;\n}\n\n/* 혜택 요약 */\n.benefits-summary {\n  margin-bottom: 10px;\n}\n\n.benefits-summary h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--ink);\n  margin: 0 0 8px 0;\n}\n\n.benefits-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n}\n\n.benefit-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  background: var(--parchment);\n  border-radius: 10px;\n  border: 1px solid rgba(123, 31, 162, 0.1);\n}\n\n.benefit-icon {\n  font-size: 20px;\n}\n\n.benefit-char {\n  width: 28px;\n  height: 28px;\n  object-fit: cover;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.passport-emblem-img {\n  width: 32px;\n  height: 32px;\n  object-fit: cover;\n  border-radius: 50%;\n  filter: drop-shadow(0 1px 3px rgba(0,0,0,0.3));\n}\n\n.benefit-text {\n  font-size: 13px;\n  color: var(--ink-light);\n}\n\n.benefit-text strong {\n  color: var(--royal-purple);\n}\n\n/* 완료 버튼 */\n.btn-complete {\n  width: 100%;\n  padding: 14px;\n  font-size: 20px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);\n  color: #fff;\n  border: none;\n  border-radius: 18px;\n  cursor: pointer;\n  transition: all 0.3s;\n  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);\n}\n\n.btn-complete:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 28px rgba(76, 175, 80, 0.4);\n}\n\n.btn-complete:active {\n  transform: translateY(0);\n}\n\n/* ==========================================\n   미등록 회원 확인 팝업\n   ========================================== */\n.confirm-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 200;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.confirm-popup {\n  background: #fff;\n  border-radius: 24px;\n  padding: 36px 32px;\n  max-width: 400px;\n  width: 90%;\n  text-align: center;\n  box-shadow:\n    0 16px 48px rgba(0, 0, 0, 0.2),\n    0 0 0 3px var(--antique-gold);\n  animation: popIn 0.3s ease;\n}\n\n.confirm-popup.auto-progress {\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);\n}\n\n@keyframes popIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.confirm-icon {\n  font-size: 56px;\n  margin-bottom: 16px;\n}\n\n.confirm-popup h3 {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--ink);\n  margin: 0 0 12px 0;\n}\n\n.confirm-popup p {\n  font-size: 18px;\n  color: var(--ink-light);\n  margin: 0 0 20px 0;\n  line-height: 1.6;\n}\n\n.confirm-phone {\n  display: inline-block;\n  padding: 10px 24px;\n  background: var(--parchment);\n  border: 2px solid var(--royal-purple-light);\n  border-radius: 12px;\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--royal-purple);\n  letter-spacing: 2px;\n  margin-bottom: 24px;\n}\n\n.confirm-buttons {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-confirm-cancel {\n  flex: 1;\n  padding: 18px;\n  font-size: 20px;\n  font-weight: 600;\n  background: #f5f5f5;\n  color: #666;\n  border: 2px solid #e0e0e0;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-confirm-cancel:active {\n  background: #e0e0e0;\n  transform: scale(0.97);\n}\n\n.btn-confirm-ok {\n  flex: 1;\n  padding: 18px;\n  font-size: 20px;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--royal-purple) 0%, var(--royal-purple-deep) 100%);\n  color: #fff;\n  border: 2px solid var(--antique-gold);\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 4px 12px rgba(123, 31, 162, 0.3);\n}\n\n.btn-confirm-ok:active {\n  transform: scale(0.97);\n}\n\n/* ==========================================\n   통합 결과: 가입 정보 요약\n   ========================================== */\n.combined-member-summary {\n  background: var(--parchment);\n  border: 2px solid var(--antique-gold-light);\n  border-radius: 16px;\n  padding: 20px 24px;\n  margin-bottom: 24px;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n}\n\n.summary-row + .summary-row {\n  border-top: 1px solid rgba(212, 175, 55, 0.2);\n}\n\n.summary-row.highlight {\n  margin-top: 4px;\n}\n\n.summary-label {\n  font-size: 18px;\n  color: var(--ink-light);\n}\n\n.summary-value {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--ink);\n}\n\n.summary-value.coins {\n  color: var(--royal-purple);\n  font-size: 24px;\n  font-weight: 700;\n}\n\n/* ==========================================\n   반응형\n   ========================================== */\n@media (max-width: 600px) {\n  .page-header {\n    padding: 16px 20px;\n    gap: 12px;\n  }\n\n  .page-header h1 {\n    font-size: 26px;\n  }\n\n  .header-icon {\n    font-size: 28px;\n  }\n\n  .header-badge {\n    font-size: 12px;\n    padding: 6px 14px;\n  }\n\n  .page-content {\n    padding: 20px;\n  }\n\n  .member-card {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .member-name {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .passport-card {\n    padding: 20px;\n  }\n\n  .benefits-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* 여권 발급 히스토리 */\n.passport-history {\n  background: #fff;\n  border-radius: 12px;\n  padding: 10px 12px;\n  margin-top: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n\n.passport-history-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink);\n  margin: 0 0 8px;\n}\n\n.passport-history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.passport-history-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  background: #f8f8f8;\n  border-left: 3px solid #ccc;\n  white-space: nowrap;\n}\n\n.passport-history-row.active {\n  border-left-color: #4CAF50;\n  background: #F1F8E9;\n}\n\n.passport-history-row.expired {\n  border-left-color: #BDBDBD;\n  background: #FAFAFA;\n  color: #999;\n}\n\n.passport-history-row.cancelled {\n  border-left-color: #EF5350;\n  background: #FFF5F5;\n  color: #bbb;\n}\n\n.ph-strikethrough {\n  text-decoration: line-through;\n  color: #bbb !important;\n}\n\n.ph-status.cancelled {\n  color: #EF5350 !important;\n  font-weight: 600;\n}\n\n.passport-history-row.event {\n  border-left-color: #7B1FA2;\n  background: #F3E5F5;\n}\n.ph-status.event {\n  color: #7B1FA2 !important;\n  font-weight: 600;\n}\n\n.passport-history-row.current-store {\n  border-left-color: var(--royal-purple);\n  background: #F3E5F5;\n}\n\n.ph-store {\n  font-weight: 600;\n  min-width: 60px;\n  color: var(--ink);\n}\n\n.passport-history-row.expired .ph-store {\n  color: #999;\n}\n\n.ph-issue, .ph-expire {\n  color: #666;\n  font-size: 11px;\n}\n\n.ph-status {\n  font-weight: 700;\n  font-size: 11px;\n  margin-left: auto;\n}\n\n.ph-status.active { color: #2E7D32; }\n.ph-status.expired { color: #999; }\n\n.ph-dup {\n  background: var(--royal-purple);\n  color: #fff;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.ph-assign-select {\n  padding: 3px 6px;\n  border: 1px solid #AB47BC;\n  border-radius: 6px;\n  background: #F3E5F5;\n  color: #7B1FA2;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  max-width: 120px;\n}\n\n.ph-assign-select:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ph-cancel-btn {\n  padding: 3px 8px;\n  border: 1px solid #ef5350;\n  border-radius: 6px;\n  background: #ffebee;\n  color: #c62828;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ph-cancel-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ph-cancel-btn:not(:disabled):hover {\n  background: #ef5350;\n  color: #fff;\n}\n\n/* 통합 여권 현황 */\n.fp-summary-bar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: #FFF8E1;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #555;\n  margin-bottom: 8px;\n}\n\n.fp-summary-divider {\n  color: #ccc;\n}\n\n.fp-current-tag {\n  display: inline-block;\n  background: #E3F2FD;\n  color: #1565C0;\n  font-size: 10px;\n  padding: 1px 5px;\n  border-radius: 4px;\n  margin-left: 4px;\n}\n\n.fp-btn-assign {\n  padding: 4px 10px;\n  border: 1px solid #FF9800;\n  border-radius: 6px;\n  background: #FFF3E0;\n  color: #E65100;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.fp-btn-assign:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.fp-btn-assign:not(:disabled):active {\n  background: #FFE0B2;\n}\n\n.fp-status.none {\n  font-size: 12px;\n  color: #999;\n}\n\n.fp-passport-count {\n  font-size: 13px;\n  color: #333;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n}\n\n.fp-store-tags {\n  display: inline-flex;\n  gap: 3px;\n  margin-left: 4px;\n}\n\n.fp-store-tag-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 1px;\n  margin-left: 3px;\n}\n\n.fp-store-tag {\n  display: inline-block;\n  background: #E8F5E9;\n  color: #2E7D32;\n  font-size: 10px;\n  padding: 1px 5px;\n  border-radius: 4px 0 0 4px;\n}\n\n.fp-tag-recall {\n  background: #E3F2FD;\n  color: #1565C0;\n  border: none;\n  font-size: 10px;\n  padding: 1px 4px;\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.fp-tag-recall:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.fp-tag-recall:not(:disabled):active {\n  background: #1565C0;\n  color: #fff;\n}\n\n.fp-passport-list {\n  margin-top: 8px;\n  border-top: 1px solid #eee;\n  padding-top: 8px;\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.fp-passport-list-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  margin-bottom: 6px;\n}\n\n.ph-owner {\n  font-size: 11px;\n  font-weight: 600;\n  color: #7B1FA2;\n  min-width: 45px;\n}\n\n/* USB 바코드/QR 리더기 섹션 */\n.barcode-reader-section {\n  background: #fff;\n  border-radius: 14px;\n  padding: 20px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  border: 3px dashed var(--royal-purple-light);\n}\n\n.barcode-icon {\n  font-size: 48px;\n  margin-bottom: 8px;\n}\n\n.barcode-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 18px;\n  color: var(--royal-purple);\n  margin: 0 0 4px;\n}\n\n.barcode-hint {\n  font-size: 13px;\n  color: var(--ink-light);\n  margin: 0 0 16px;\n}\n\n\n/* 여권 페이지 카메라 스캐너 오버라이드 (미사용, 하위 호환) */\n.passport-scanner-wrap {\n  flex: 1;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.passport-scanner-wrap .qr-scanner {\n  max-width: none !important;\n  flex-direction: column !important;\n  height: 100%;\n}\n\n.passport-scanner-wrap .qr-scanner-viewport {\n  width: 100% !important;\n  height: 100% !important;\n  aspect-ratio: auto !important;\n}\n\n.passport-scanner-wrap .qr-scanner-guide {\n  margin-top: 4px !important;\n  font-size: 12px !important;\n  writing-mode: horizontal-tb !important;\n}\n\n.passport-scanner-wrap .qr-scanner-error {\n  aspect-ratio: auto !important;\n  height: 100% !important;\n}\n\n/* 커스텀 확인 팝업 */\n.pp-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.pp-confirm-popup {\n  background: #fff;\n  border-radius: 16px;\n  padding: 28px 32px;\n  max-width: 340px;\n  width: 90%;\n  text-align: center;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n}\n\n.pp-confirm-icon {\n  font-size: 40px;\n  margin-bottom: 12px;\n}\n\n.pp-confirm-message {\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 16px;\n  color: #333;\n  line-height: 1.5;\n  margin: 0 0 20px;\n  white-space: pre-line;\n}\n\n.pp-confirm-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.pp-confirm-cancel {\n  flex: 1;\n  padding: 12px;\n  border: 2px solid #ddd;\n  border-radius: 12px;\n  background: #fff;\n  color: #666;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pp-confirm-cancel:active {\n  background: #f5f5f5;\n}\n\n.pp-confirm-ok {\n  flex: 1;\n  padding: 12px;\n  border: none;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #ef5350, #c62828);\n  color: #fff;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pp-confirm-ok:active {\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
